import { FeatureFlag } from "../FeatureFlag/FeatureFlag";
import infoIcon from "./images/info.svg";
import styles from "./ProductContactInfo.module.scss";

const ProductContactInfo = ({ product }) => {
    return (
        <div className={styles.productContactInfo}>
            <div className={styles.title}>Contact</div>

            <div className={styles.manufacturer}>
                <span>Manufacturer name & Address: </span> <span>{product.brand?.manufacturer?.name}</span>
            </div>
            <div className={styles.liability_info}>
                <img src={infoIcon} height={22} alt="info" />
                <div>
                    We are updating this information, Please revisit{" "}
                    <FeatureFlag name="reportUs">
                        <span
                            style={{
                                textDecoration: "underline",
                                color: "var(--color-primary)",
                                fontWeight: "bold",
                                cursor: "pointer",
                            }}
                        >
                            Report us.
                        </span>{" "}
                    </FeatureFlag>
                </div>
            </div>

            <div className={styles.report}>
                <span>For complaints please report </span>
                <span>here</span>
            </div>
        </div>
    );
};

export default ProductContactInfo;
